import { MuscleRegime } from "myfitworld-model";

export default [
  { value: MuscleRegime.DYNAMIC, label: 'dynamic' },
  { value: MuscleRegime.ISOMETRIC, label: 'isometric' },
  { value: MuscleRegime.COMBINED, label: 'combined' }
];
